export const CYBER = {
  codProducto: 'lnPresCyber',
  prodCodigoCore: 'lnPresCyber',
  proTipoPlan: 'Abierto',

  urls: {
    datosAsegurado: '/cyber-datos-asegurado',
    preguntas: '/cyber-preguntas',
    planes: '/cyber-planes',
    resumen: '/cyber-resumen',
    cliente: '/cyber-cliente',
    asegurado:'/cyber-asegurado',
    vigencia:'/cyber-vigencia',
    pago:'/cyber-pago',
    facturacion:'/facturacion/tipo-persona',
  },

  /********Produccion********/
  encriptar: {
    resumen: true,
    catalogo: true,
    actualizar: true,
    tarifar: true,
    recuperar: true,
    asegurado: true,
  },

  logueoRequerido: true,
  /********Produccion********/

  // logueoRequerido: false,
  /********Desarrollo********/
};
